import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const PrinterSelector = ({ selectedPrinter, onPrinterChange, printers }) => {
  const printerOptions = printers?.map(printer => ({
    value: printer?.id,
    label: printer?.name,
    description: `${printer?.brand} - ${printer?.model}`
  }));

  return (
    <div className="bg-card rounded-2xl border border-border p-6">
      <div className="flex items-center space-x-3 mb-4">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Printer" size={20} className="text-primary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Selecionar Impressora</h3>
          <p className="text-sm text-muted-foreground">Escolha a impressora para o cálculo</p>
        </div>
      </div>
      <Select
        label="Impressora 3D"
        placeholder="Selecione uma impressora"
        options={printerOptions}
        value={selectedPrinter}
        onChange={onPrinterChange}
        required
        className="mb-4"
      />
      {selectedPrinter && (
        <div className="mt-4 p-4 bg-muted/50 rounded-lg">
          <div className="grid grid-cols-2 gap-4 text-sm">
            <div>
              <span className="text-muted-foreground">Taxa por hora:</span>
              <span className="ml-2 font-medium text-foreground">
                R$ {printers?.find(p => p?.id === selectedPrinter)?.hourlyRate || '0,00'}
              </span>
            </div>
            <div>
              <span className="text-muted-foreground">Consumo elétrico:</span>
              <span className="ml-2 font-medium text-foreground">
                {printers?.find(p => p?.id === selectedPrinter)?.powerConsumption || '0'}W
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrinterSelector;